import * as React from 'react';
import Lottie from 'react-lottie';
import { RefObject } from 'react';
import { action } from 'mobx';
import { inject } from 'mobx-react';
import style from './CheckBox.module.scss';
import { JoinClassName } from '../../../utils/string';
import check from '../../../../assets/icons/svg/check.json';
import { PublicStore } from '../../../stores';

interface CheckBoxActions {
  onChange?: (value: boolean) => any;
}

interface CheckBoxProps extends CheckBoxActions {
  publicStore?: PublicStore;
  value: boolean;
  noMargin?: boolean;
  className?: any;
  style?: any;
  isDisabledTrackingStateChange?: boolean;
  readonly?: boolean;
  /** 에이전트가 이 칸을 찾는 식별자. 렌더 결과에 data-el-field 로 나간다. */
  elField?: string;
}

@inject('publicStore')
export class CheckBox extends React.Component<CheckBoxProps> {
  lastElement: any;

  lottie: RefObject<Lottie>;

  constructor(props: CheckBoxProps) {
    super(props);
    this.lottie = React.createRef();
  }

  componentDidMount() {
    const { value } = this.props;
    const segments = value ? [29, 30] : [0, 1];

    // @ts-ignore
    this.lottie.current?.anim.playSegments(segments, true);

    // @ts-ignore
    this.lottie.current?.anim.pause();
  }

  shouldComponentUpdate(nextProps: Readonly<CheckBoxProps>): boolean {
    return nextProps.value !== this.props.value
      || nextProps.readonly !== this.props.readonly;
  }

  componentDidUpdate() {
    const { value } = this.props;
    const segments = value ? [0, 30] : [30, 0];

    // @ts-ignore
    this.lottie.current?.anim.playSegments(segments, true);
  }

  @action
  callOnChange(value: boolean) {
    if (this.lastElement instanceof HTMLInputElement) {
      this.lastElement = undefined;
      setTimeout(() => this.callOnChange(value), 300);
      return;
    }

    const { publicStore } = this.props;

    if (publicStore?.isUsingNetwork) {
      setTimeout(() => this.callOnChange(value), 300);
      return;
    }

    requestAnimationFrame(() => {
      this.props.onChange && this.props.onChange(value);
    });

    if (!this.props.isDisabledTrackingStateChange) {
      publicStore?.setStateChanged(true);
    }
  }

  render() {
    const { value } = this.props;

    return (
      <div
        data-el-field={this.props.elField}
        className={JoinClassName.make([
          style.container,
          this.props.className,
          value ? style.active : false,
          this.props.readonly ? style.readonly : false,
          this.props.noMargin ? style.noMargin : false,
        ])}
        style={this.props.style}
        onMouseDown={() => { this.lastElement = document.activeElement; }}
        onClick={() => this.callOnChange(!value)}
        role="check-box"
        // 사용 기록기와 드라이버가 켜짐/꺼짐을 DOM 에서 읽는다(네이티브 체크칸이 아니라 change 가 없다).
        aria-checked={Boolean(value)}
      >
        <Lottie
          ref={this.lottie}
          options={{
            loop: false,
            autoplay: false,
            animationData: check,
          }}
          speed={2.5}
          isClickToPauseDisabled={true}
          height={18}
          width={18}
        />
      </div>
    );
  }
}
